var _classCallCheck = require("F:\\Dev\\tarjemle-web\\tarjemle-landing-page\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("F:\\Dev\\tarjemle-web\\tarjemle-landing-page\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("F:\\Dev\\tarjemle-web\\tarjemle-landing-page\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("F:\\Dev\\tarjemle-web\\tarjemle-landing-page\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("F:\\Dev\\tarjemle-web\\tarjemle-landing-page\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var React = require('react');

var hoistStatics = require('hoist-non-react-statics');

var objectAssign = require('object-assign');

var Cookies = require('universal-cookie');

var subscribes = {};
var translations = {};
var defaultLanguage = 'en';
var language = 'en';
var count = 0;
var cookies;
var cookieName = 'language';
var cookieOption = {
  path: '/',
  maxAge: 157680000
};

function subscribe(cb) {
  var newId = count;
  subscribes[newId] = cb;
  count += 1;
  return newId;
}

function unsubscribe(id) {
  delete subscribes[id];
}

function triggerSubscriptions() {
  Object.keys(subscribes).forEach(function (id) {
    new Promise(function (resolve) {
      subscribes[id]();
      resolve();
    }).then();
  });
}

function getLanguages() {
  return Object.keys(translations);
}

function getDefaultLanguage() {
  return defaultLanguage;
}

function getLanguage() {
  return language;
}

function setDefaultLanguage(lang) {
  defaultLanguage = lang;
  language = lang;
}

function setLanguage(lang) {
  if (getLanguages().indexOf(lang) === -1) {
    return;
  }

  language = lang;
  triggerSubscriptions();

  if (cookies && process.browser) {
    cookies.set(cookieName, language, cookieOption);
  }
}

function setLanguageCookie(name, option, reqCookie) {
  cookies = new Cookies(reqCookie);
  cookieName = name || cookieName;
  cookieOption = Object.assign({}, cookieOption, option);
  var lang = cookies.get(name);

  if (lang) {
    setLanguage(lang);
  }
}

function setTranslations(userTranslations) {
  translations = userTranslations;
  triggerSubscriptions();
}

function setDefaultTranslations(userTranslations) {
  if (getLanguages().length !== 0) {
    setTranslations(userTranslations);
    return;
  }

  translations = userTranslations;
}

function getTranslation(lang) {
  return translations[lang];
}

function _t(path, params, lang) {
  var selectLang = lang || language;

  function fallback() {
    if (selectLang !== defaultLanguage) {
      return _t(path, params, defaultLanguage);
    }

    return path;
  }

  var translationObj = getTranslation(selectLang);

  if (!translationObj) {
    return fallback();
  }

  var translationKeys = path.split('.');
  var translation = '';
  translationKeys.forEach(function (key) {
    var temp = translationObj[key];

    if (typeof translationObj[key] === 'object') {
      translationObj = translationObj[key];
    } else if (typeof temp === 'string') {
      translation = temp;
    }
  });

  if (!translation) {
    return fallback();
  }

  if (params) {
    Object.keys(params).forEach(function (key) {
      var replace = "{".concat(key, "}");
      translation = translation.replace(replace, params[key]);
    });
  }

  return translation;
}

function translate(Component) {
  var TranslatedComponet =
  /*#__PURE__*/
  function (_React$Component) {
    "use strict";

    _inherits(TranslatedComponet, _React$Component);

    function TranslatedComponet() {
      _classCallCheck(this, TranslatedComponet);

      return _possibleConstructorReturn(this, _getPrototypeOf(TranslatedComponet).apply(this, arguments));
    }

    _createClass(TranslatedComponet, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this = this;

        this.id = subscribe(function () {
          return _this.forceUpdate();
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        unsubscribe(this.id);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(Component, objectAssign({}, this.props, {
          t: function t(key, args, lang) {
            return _t(key, args, lang);
          }
        }));
      }
    }]);

    return TranslatedComponet;
  }(React.Component);

  return hoistStatics(TranslatedComponet, Component);
}

module.exports = {
  getLanguages: getLanguages,
  getDefaultLanguage: getDefaultLanguage,
  getLanguage: getLanguage,
  setDefaultLanguage: setDefaultLanguage,
  setLanguage: setLanguage,
  setLanguageCookie: setLanguageCookie,
  setDefaultTranslations: setDefaultTranslations,
  setTranslations: setTranslations,
  translate: translate,
  subscribe: subscribe,
  unsubscribe: unsubscribe,
  t: _t
};